export default class Platform {
  static isMobileDevice() {
    return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
      navigator.userAgent
    );
  }

  static windowWidth() {
    return window.innerWidth;
  }

  static useMobileLayout() {
    return this.isMobileDevice() && this.windowWidth() < 768;
  }

  static useMobileNavigation() {
    return this.isMobileDevice() || this.windowWidth() < 1024;
  }
}
